import * as Icons from '../components/icons/tools/index'
export class Tool {
  title?: keyof typeof Icons
  imageSlug?: keyof typeof Icons
  color?: string
}